module.exports = __webpack_public_path__ + "img/three.45582e5e.jpg";